import { APIHelper } from '@archistarai/auth-frontend';

export default {
  async update(pipelineId: number, siteId: number, asessmentId: number, value: string) {
    return APIHelper.ManageAPI.put(`pipeline/${pipelineId}/site/${siteId}/assessment/${asessmentId}`, {
      value: value
    });
  }
};
